// User types aligned with backend UserDTO
import { UserRole } from '../enums'
import { getUserRoleLabel as i18nGetUserRoleLabel } from '../i18n'

export interface User {
  id: number
  businessId: number
  phoneNumber: string
  name: string
  email: string
  password: string // Usually '********' from backend
  userRole: UserRole
  isActive: boolean
  createdAt: Date | string
  updatedAt: Date | string
}

export interface UserCreateData {
  phoneNumber: string
  name: string
  email?: string
  password: string
  userRole?: UserRole
  businessId?: number
  isActive?: boolean
}

export interface UserUpdateData {
  name?: string
  email?: string
  password?: string
  businessId?: number
  userRole?: UserRole
  isActive?: boolean
}

// Helper functions
export function isAdminUser(user: User): boolean {
  return user.userRole === UserRole.SYSTEM_ADMIN || user.userRole === UserRole.MONITOR
}

export function isBusinessOwner(user: User): boolean {
  return user.userRole === UserRole.BUSINESS_OWNER
}

export function isEmployee(user: User): boolean {
  return user.userRole === UserRole.BUSINESS_EMPLOYEE
}

export function isClient(user: User): boolean {
  return user.userRole === UserRole.CLIENT
}


/**
 * Get translated user role label using i18n
 * This function uses the translation system to get the localized role label
 */
export function getUserRoleLabel(userRole: UserRole): string {
  // UserRole enum values are already strings (e.g., 'system_admin')
  return i18nGetUserRoleLabel(userRole)
}

